import { fromJS } from 'immutable';
import * as constants from './constants';
import { equals, not, isEmpty, filter, keys, any, anyPass, isNil, without, either, path, contains, propOr, prop, merge } from 'ramda';

const isNotEmpty = item => not(isEmpty(item));
const isNilOrEmpty = either(isNil, isEmpty);
const filterForKey = (obj, keyToFind) => filter(item => equals(item, keyToFind), keys(obj));

const handlePropChecking = (payload, state) => {
  const jsState = state.toJS();
  const membershipsArray = jsState.memberships;
  const otherMembership = jsState.otherMembership;
  const membership = jsState.membership;
  if (isNotEmpty(filterForKey(payload, 'memberships'))) {
    const isMembershipArrayEmpty = membershipsArray.length < 0;
    return state.set('disableMembershipsSaveButton', isMembershipArrayEmpty);
  }
  if (payload.membership || payload.otherMembership) {
    const memberObj = payload.membership ? membership : otherMembership;
    if (memberObj.name && isNotEmpty(memberObj.name)) {
      const isOrganizationDuplicated = contains(propOr('', 'name', otherMembership).toLowerCase(), membershipsArray.map(obj => prop('name', obj).toLowerCase()));
      return state.set(payload.membership ? 'membershipValidated' : 'otherMembershipValidated', true)
      .set('showAddAnotherOrganizationButton', !isOrganizationDuplicated)
      .set('showDuplicateOrganizationError', isOrganizationDuplicated)
      .set('disableMembershipsSaveButton', isOrganizationDuplicated);
    }
  }
  if (payload.resetOtherMembershipObj) {
    if (!isEmpty(otherMembership) || !isEmpty(membership)) {
      const membershipObj = !isEmpty(otherMembership) ? otherMembership : membership;
      if (jsState.membershipValidated || jsState.otherMembershipValidated) {
        return state.set('memberships', fromJS(membershipsArray.concat([membershipObj])))
        .set('membership', fromJS({}))
        .set('otherMembership', fromJS({}))
        .set('membershipValidated', false)
        .set('otherMembershipValidated', false);
      }
      return state.set('membership', fromJS({}))
      .set('otherMembership', fromJS({}));
    }
    return state.set('otherMembership', fromJS({}))
    .set('membership', fromJS({}));
  }
  return state;
};

const initialState = fromJS({
  membershipsEditState: false,
  originalMemberships: [],
  memberships: [],
  savingMembershipsInfo: false,
  disableMembershipsSaveButton: true,
  otherChecked: false,
  membership: {},
  membershipValidated: false,
  otherMembership: {},
  otherMembershipValidated: false,
  showAddAnotherOrganizationButton: false,
  showDuplicateOrganizationError: false,
  membershipsExistFromDB: false,
  savingMembershipInfo: false,
  listOfAvailableOrganizations: [],
  showListOfOrganizationsDropdown: false,
});

export default function memberships(state = initialState, { type, payload, profile }) {
  switch (type) {
    case constants.GOT_BADGES:
      return state.set('listOfAvailableOrganizations', fromJS(payload));
    case 'GET_PROFILE':
      return state.set('memberships', without([state.get('otherMembership')], fromJS(profile.companyBadges || [])))
      .set('membershipsExistFromDB', Boolean(path(['companyBadges', 'length'], profile)) > 0)
      .set('originalMemberships', fromJS(profile.companyBadges || []));
    case constants.UPDATE_PROPS:
      if (payload.cancelMembershipsClicked) {
        const checkMemberships = state.get('otherMembershipValidated') && isNilOrEmpty(state.get('otherMembership')) ? state.get('memberships') : state.get('originalMemberships');
        return state.set('memberships', fromJS(checkMemberships))
        .set('otherMembership', fromJS({}))
        .set('otherMembershipValidated', false)
        .set('membershipValidated', false)
        .set('membership', fromJS({}))
        .set('membershipsEditState', false)
        .set('showAddAnotherOrganizationButton', false);
      }
      return handlePropChecking(payload, state.merge(fromJS(payload)));
    case constants.DELETE_ORGANIZATION_IN_PROFILE:
      const findOrgToDelete = state.get('memberships').toJS().map(obj => {
        if (obj.name === payload && obj.companyBadgeId) return merge(obj, { delete: true });
        if (obj.name === payload) return {};
        return obj;
      });
      return state.set('memberships', fromJS(findOrgToDelete.filter(org => isNotEmpty(org))));
    case constants.EDIT_PROFILE_BADGE_STARTING:
      return state.set('savingMembershipInfo', true);
    case constants.EDIT_PROFILE_BADGE_FINISHED:
      return state.set('savingMembershipInfo', false)
      .set('memberships', fromJS(payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/profile/memberships/reducer.js